// Imports => React
import { useState, useEffect, useMemo, memo } from 'react';
import { withStore } from '@stores';
import { observer } from 'mobx-react-lite';
import { Fade } from 'react-awesome-reveal';
import clsx from 'clsx';

// Imports => Constants
import { TITLES } from '@constants';
import { KEYS, THEMES, TYPES } from '@opp/ui-kit';

// Imports => Utilities
import { AcIsSet, AcIsUndefined } from '@opp/ui-kit';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcHeading,
  AcCard,
} from '@opp/ui-kit';

const _CLASSES = {
  MAIN: 'ac-profile-settings-tab ac-profile__grid-container',
};

const AcProfielSettingsTab = ({ data, store: { profile, ui } }) => {
  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  });

  return (
    <div className={getMainClassNames}>
      <AcCard className={'ac-profile__column ac-profile__column--half'}>
        <AcHeading
          theme={THEMES.DARK}
          rank={6}
          className={'h-margin-bottom-25'}
        >
                    Timezone & language
        </AcHeading>
      </AcCard>
    </div>
  );
};

export default withStore(observer(AcProfielSettingsTab));
